const AiImportButton = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.71935 3.25776C4.81549 3.01401 5.16045 3.01401 5.25658 3.25776L6.4937 6.39451C6.52305 6.46893 6.58195 6.52784 6.65637 6.55719L9.79312 7.7943C10.0369 7.89044 10.0369 8.2354 9.79312 8.33153L6.65637 9.56865C6.58195 9.598 6.52305 9.6569 6.4937 9.73132L5.25658 12.8681C5.16045 13.1118 4.81549 13.1118 4.71935 12.8681L3.48224 9.73132C3.45289 9.6569 3.39398 9.598 3.31956 9.56865L0.18281 8.33153C-0.0609363 8.2354 -0.0609369 7.89044 0.182809 7.7943L3.31956 6.55719C3.39398 6.52784 3.45289 6.46893 3.48224 6.39451L4.71935 3.25776Z"
      fill="white"
    />
    <path
      d="M9.83446 1.04038C9.88253 0.918506 10.055 0.918506 10.1031 1.04038L10.8033 2.81583C10.818 2.85304 10.8474 2.8825 10.8846 2.89717L12.6601 3.5974C12.782 3.64547 12.782 3.81795 12.6601 3.86601L10.8846 4.56624C10.8474 4.58092 10.818 4.61037 10.8033 4.64758L10.1031 6.42303C10.055 6.54491 9.88253 6.54491 9.83446 6.42303L9.13423 4.64758C9.11956 4.61037 9.0901 4.58092 9.05289 4.56624L7.27744 3.86601C7.15557 3.81795 7.15557 3.64547 7.27744 3.5974L9.05289 2.89717C9.0901 2.8825 9.11956 2.85304 9.13423 2.81583L9.83446 1.04038Z"
      fill="white"
    />
  </svg>
);

export default AiImportButton;
